import './assets/base.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'
import { toast } from 'vue-sonner'

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
  toast('There was an unexpected issue')
  console.error(err)
}

if (process.env.NODE_ENV === 'production')
  Sentry.init({
    app,
    dsn: 'https://906face9c294ec733baf3a8d5148c49c@o1408848.ingest.us.sentry.io/4509133799358464',
    integrations: [Sentry.browserTracingIntegration({ router })],
    tracesSampleRate: 1.0,
  })

app.use(createPinia())
app.use(router)

app.mount('#app')
